"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommodityDetailsResponse = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class CommodityDetailsResponse extends base_models_1.Serializable {
}
exports.CommodityDetailsResponse = CommodityDetailsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '01111123',
        description: 'Account ID',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CommodityDetailsResponse.prototype, "accountId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '207',
        description: 'House Number',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CommodityDetailsResponse.prototype, "houseNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'A',
        description: 'House Number Extension',
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CommodityDetailsResponse.prototype, "houseNumberExtension", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'NL',
        description: 'Country ID',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CommodityDetailsResponse.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2234BB',
        description: 'Postal Code',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], CommodityDetailsResponse.prototype, "postalCode", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: false,
        description: 'Commodity Exists',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    tslib_1.__metadata("design:type", Boolean)
], CommodityDetailsResponse.prototype, "commodityExists", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 0.23,
        description: 'Rate',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], CommodityDetailsResponse.prototype, "rate", void 0);
